import { useQuery } from "@tanstack/react-query";
import {
  manageArticleApi,
  articleQueryKeys,
} from "../../../../entities/article";

export const useArticleDetailQuery = (articleId: string | undefined) => {
  return useQuery({
    queryKey: articleQueryKeys.detail(articleId!),
    queryFn: () => manageArticleApi.getArticle(articleId!),
    enabled: !!articleId,
    staleTime: 5 * 60 * 1000, // 5분
    gcTime: 10 * 60 * 1000, // 10분
  });
};
